import { IValidatorField } from "dromo-uploader-js";

import { BidRequestFieldType } from "../types";
import { zipValidator } from "./validators";

const createStopsFields = (
  n: number,
  options?: { dateRequired?: boolean; dateSelected?: boolean }
): BidRequestFieldType[] => {
  return new Array(n)
    .fill(0)
    .map((_, index): BidRequestFieldType[] => {
      let validators: IValidatorField[] | undefined;

      if (index < 1) {
        validators = [{ validate: "required" }];
      }

      if (index >= 1) {
        validators = [
          {
            validate: "require_with",
            fields: [`stop_${index + 1}_city`, `stop_${index + 1}_state`],
          },
        ];
      }

      return [
        {
          key: `stop_${index + 1}_street`,
          label: "street",
          required: index < 1,
          selected: true,
          additionalI18NOptions: {
            location: `$t(shipper:bids.fieldNames.stopN, {\"n\": ${index + 1} })`,
          },
          type: "string",
        },
        {
          key: `stop_${index + 1}_city`,
          label: "city",
          required: index < 1,
          selected: true,
          additionalI18NOptions: {
            location: `$t(shipper:bids.fieldNames.stopN, {\"n\": ${index + 1} })`,
          },
          validators,
          type: "string",
        },
        {
          key: `stop_${index + 1}_state`,
          label: "state",
          required: index < 1,
          selected: true,
          additionalI18NOptions: {
            location: `$t(shipper:bids.fieldNames.stopN, {\"n\": ${index + 1} })`,
          },
          validators,
          type: "string",
        },
        {
          key: `stop_${index + 1}_zip`,
          label: "zip",
          required: false,
          selected: true,
          additionalI18NOptions: {
            location: `$t(shipper:bids.fieldNames.stopN, {\"n\": ${index + 1} })`,
          },
          validators: [zipValidator],
          type: "string",
        },
        {
          key: `stop_${index + 1}_name`,
          label: "location",
          required: false,
          selected: false,
          additionalI18NOptions: {
            location: `$t(shipper:bids.fieldNames.stopN, {\"n\": ${index + 1} })`,
          },
          type: "string",
        },
        {
          key: `stop_${index + 1}_date`,
          label: "locationDate",
          required: options?.dateRequired ?? false,
          selected: (options?.dateSelected || options?.dateRequired) ?? false,
          additionalI18NOptions: {
            location: `$t(shipper:bids.fieldNames.stopN, {\"n\": ${index + 1} })`,
          },
          validators: [
            ...(options?.dateRequired ? [{ validate: "required" as const }] : []),
            {
              validate: "require_with",
              fields: [`stop_${index + 1}_appointment_start`, `stop_${index + 1}_appointment_end`],
            },
          ],
          type: "date",
        },
        {
          key: `stop_${index + 1}_appointment_start`,
          label: "appointment_start",
          required: false,
          selected: false,
          additionalI18NOptions: {
            location: `$t(shipper:bids.fieldNames.${index + 1})`,
          },
          validators: [
            {
              validate: "require_with",
              fields: [`stop_${index + 1}_appointment_end`],
            },
          ],
          type: "time",
        },
        {
          key: `stop_${index + 1}_appointment_end`,
          label: "appointment_end",
          required: false,
          selected: false,
          additionalI18NOptions: {
            location: `$t(shipper:bids.fieldNames.${index + 1})`,
          },
          type: "time",
        },
      ];
    })
    .flat();
};

export default createStopsFields;
